export default "__VITE_ASSET__CIOq0Ujo__"